import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removehypen',
    standalone: false
})
export class RemovehypenPipe implements PipeTransform {

  transform(value: string): string {
    return value.replace(/-/g, ' ');
  }

}
